class Availability{

  current;
  total;
  color;
  name;

  constructor(name, color){
    this.current = 0;
    this.total = 0;
    this.color = color;
    this.name = name;
  }

  add(state){
    this.total++;
    this.current += state === 0 || state===2 ? 1 : 0;
  }

  display(){
    return this.total === 0 ? "-" : this.current;
  }

}
export default Availability;
